import { Flex, Icon, Text } from '@chakra-ui/react';
import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';

const StaleOfferBanner = () => (
  <Flex
    role="alert"
    align="center"
    gap="10px"
    bg="offerStaleBannerBG"
    borderWidth="1px"
    borderColor="offerStaleBannerBorder"
    borderRadius="8px"
    px="14px"
    py="10px"
    mb="16px"
  >
    <Icon as={FaExclamationTriangle} boxSize="14px" color="offerStaleBannerInk" flexShrink={0} />
    <Text fontSize="12px" color="offerStaleBannerInk" fontWeight="500" lineHeight="1.4">
      This offer just changed. Close and refresh to see the latest.
    </Text>
  </Flex>
);

export default StaleOfferBanner;
